import { render, staticRenderFns } from "./SlideFormRealShipment.vue?vue&type=template&id=eda981d2&scoped=true"
import script from "./SlideFormRealShipment.vue?vue&type=script&lang=js"
export * from "./SlideFormRealShipment.vue?vue&type=script&lang=js"
import style0 from "./SlideFormRealShipment.vue?vue&type=style&index=0&id=eda981d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eda981d2",
  null
  
)

export default component.exports